import APITemplate from '@/api/APITemplate'

const url = '/api/characteristic'
const template = APITemplate(url)

export default {
  ...template
}
